

export default {
    namespaced: true,
    state: {
        opd_selected : null
        //
        // structor of opd_selected
        //
        // opd_selected={
        //     acceptby:"",
        //     age :"",
        //     automate: "",
        //     cancleby :"",
        //     date:"",
        //     dateaccept: "",
        //     datecancle:"",
        //     datereject:"",
        //     datereq:"",
        //     dateresult:"",
        //     gender:"",
        //     idlab:"",
        //     idopd:"" ,
        //     kind: "",
        //     opdname: "",
        //     owner_name: "" ,
        //     rejectby: "",
        //     reqby: "",
        //     resultby: "",
        //     status: "",
        //     timeaccept: "",
        //     timecancle : "",
        //     timereject : "" ,
        //     timereq : "",
        //     timeresult: "",
        //     type : ""
        // }
     },

    getters: {



     },

    mutations: {
        setIDOPDSelected (state, opd_selected) {
            state.opd_selected = opd_selected
        },


    },

    actions: {

        setupIDOPDTarget({commit},opd_selected){
            commit('setIDOPDSelected', opd_selected)
        },

     }
}